import {
  GET_PIPELINE,
  GET_PIPELINE_COMPLETED,
  GET_PIPELINE_FAILED,
  GET_EVENEMENT,
  GET_EVENEMENT_COMPLETED,
  GET_EVENEMENT_FAILED,
  GET_EVENEMENT_CONSTANTS_COMPLETED,
} from "./actions";

const initialState = {
  pipeline: {
    aQualifier: [],
    colonnes: {
      devis_a_faire: [],
      devis_envoyes: [],
      devis_valides: [],
      a_facturer: [],
    },
    isLoading: false,
    isInitialized: false,
  },
  currentEvenement: {
    data: null,
    isLoading: false,
  },
  constants: null,
};

const reducers = (state = initialState, action) => {
  switch (action.type) {
    case GET_PIPELINE:
      return { ...state, pipeline: { ...state.pipeline, isLoading: true } };
    case GET_PIPELINE_COMPLETED:
      return {
        ...state,
        pipeline: {
          aQualifier: action.payload.result.a_qualifier || [],
          colonnes: action.payload.result.colonnes || initialState.pipeline.colonnes,
          isLoading: false,
          isInitialized: true,
        },
      };
    case GET_PIPELINE_FAILED:
      return { ...state, pipeline: { ...state.pipeline, isLoading: false, isInitialized: true } };

    case GET_EVENEMENT:
      return { ...state, currentEvenement: { ...state.currentEvenement, isLoading: true } };
    case GET_EVENEMENT_COMPLETED:
      return { ...state, currentEvenement: { data: action.payload.result.evenement, isLoading: false } };
    case GET_EVENEMENT_FAILED:
      return { ...state, currentEvenement: { data: null, isLoading: false } };

    case GET_EVENEMENT_CONSTANTS_COMPLETED:
      return { ...state, constants: action.payload.result };

    default:
      return state;
  }
};

export default reducers;
